import { render, staticRenderFns } from "./PublishingContractsSubCataloguesReadOnlyPanelDialog.vue?vue&type=template&id=2a270b2e"
import script from "./PublishingContractsSubCataloguesReadOnlyPanelDialog.vue?vue&type=script&lang=js"
export * from "./PublishingContractsSubCataloguesReadOnlyPanelDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports